import "../styles/company.css";

export function CompanyStatement() {
  return (
    <section className="section company-section" id="company">
      <h2 className="company-statement">
        Spaceport Labs is a research and development studio focused on real estate technology.
      </h2>
    </section>
  );
}
